import { FC, ReactNode } from 'react';
import { Link } from '@mui/material';

interface DataGridLinkProps {
  content: ReactNode;
  link: string;
}

export const DataGridLink: FC<DataGridLinkProps> = ({ link, content }) => {
  return (
    <Link
      href={link}
      sx={{
        textDecoration: 'none',
        '&:hover': {
          textDecoration: 'underline',
        },
      }}
    >
      {content}
    </Link>
  );
};
